import { AuthController } from "@somewear/auth";
import Loader from "@web/common/Loader";
import Paths from "@web/common/Paths";
import * as React from "react";
import { Suspense, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import Config from "../config/Config";
import { Background } from "../setup/SetupCommon";
import LoginController from "./LoginController";
import SignUpView from "./signup/SignUpView";
import SubscriptionSelection from "./SubscriptionSelection";

const LandingView = React.lazy(() => import("./LandingView"));
const PhoneController = React.lazy(() => import("./PhoneController"));

const LandingRouter: React.FunctionComponent = () => {
	const [isSignUpSubmitting, setIsSignUpSubmitting] = useState(false);

	const user = AuthController.service.getCurrentAuthUser();
	let content: React.ReactNode;

	if (user !== undefined && !isSignUpSubmitting) {
		content = (
			<Switch>
				{!Config.firebase.enable && <Redirect from={Paths.All} to={Paths.Root} />}
				<Route path={Paths.Phone}>
					<Suspense fallback={<Loader fullScreen />}>
						<PhoneController />
					</Suspense>
				</Route>
				<Route path={Paths.Subscription}>
					<SubscriptionSelection />
				</Route>
				<Redirect
					from={Paths.All}
					to={user.phoneNumber ? Paths.Subscription : Paths.Phone}
				/>
			</Switch>
		);
	} else {
		content = (
			<Switch>
				<Redirect from={Paths.Subscription} to={Paths.Root} />
				<Redirect from={Paths.Phone} to={Paths.Root} />
				<Route path={Paths.Email} component={LoginController} />
				<Route path={Paths.SignInPhone} component={LoginController} />
				<Route path={Paths.Signup}>
					<SignUpView
						isSubmitting={isSignUpSubmitting}
						setIsSubmitting={(isSubmitting) => setIsSignUpSubmitting(isSubmitting)}
					/>
				</Route>
				{!Config.firebase.enable && <Redirect from={Paths.Root} to={Paths.Email} />}
				<Route
					path={Paths.Root}
					component={() => (
						<Suspense fallback={<Loader fullScreen />}>
							<LandingView />
						</Suspense>
					)}
				/>
			</Switch>
		);
	}

	return (
		<Background>
			<div className="container flex justify-center items-center">{content}</div>
			<div id="recaptcha" />
		</Background>
	);
};

export default LandingRouter;
